import { useCartActions } from '../../contexts/StoreContext';
import { founder, salon } from '../../data/content';
import { shopLabels } from '../../data/shopLabels';
import { isAllSoldOut } from '../../core/rules/stock';
import { euro } from '../../core/format/currency';
import type { Product, Routine } from '../../core/types/catalog';
type Props = {
  result: Routine;
  totals: {
    items: Product[];
    price: number;
    months: string;
  };
  onClose: () => void;
};
const primary = 'flex min-h-[52px] w-full items-center justify-between gap-3 rounded-full bg-ink px-6 text-[15px] text-shell transition-[background-color,transform] duration-150 ease-soft hover:bg-clay active:scale-[0.98]';

/**
 * De vaste onderkant van de lade bij de uitslag: wat het kost, hoe lang het meegaat, en één
 * knop om alles in de mand te zetten. Altijd in beeld, hoe lang de uitslag ook is.
 * Alles uitverkocht: geen knop die alleen een foutmelding geeft, maar een appje naar Sarah.
 */
export function QuizResultFooter({
  result,
  totals,
  onClose
}: Props) {
  const {
    addRoutine
  } = useCartActions();
  if (isAllSoldOut(totals.items)) {
    return <a href={salon.whatsapp} target="_blank" rel="noreferrer" className={`${primary} justify-center`} data-id="element-8217" data-mp="2pndgxwtqin35">
        {shopLabels.soldOutShort} · vraag {founder.firstName} om een alternatief
        <span className="sr-only" data-id="element-8218" data-mp="2fpz221ngm6cy">{shopLabels.viaWhatsApp}</span>
      </a>;
  }
  return <button type="button" onClick={() => {
    addRoutine(result.id, {
      via: 'huidadvies'
    });
    onClose();
  }} className={primary} data-id="element-8219" data-mp="3dd7t0c68c7mc">
      <span className="text-left leading-tight" data-id="element-8220" data-mp="38f677jhf5u76">
        Protocol in de mand
        <span className="block text-[12px] text-shell/80" data-id="element-8221" data-mp="33md2uwpv4nvm">Gaat {totals.months} mee</span>
      </span>
      <span className="font-display text-xl tabular-nums" data-id="element-8222" data-mp="2yo1w4uuv6thm">{euro(totals.price)}</span>
    </button>;
}